import RegisterForm from "./Container"

export default RegisterForm
